import { IPopoverMenuDivider, IPopoverMenuItem } from './PopoverMenu.types';

export function filterPopoverMenuItems(items: IPopoverMenuItem[]): IPopoverMenuItem[] {
  return items.reduce<IPopoverMenuItem[]>((acc, item) => {
    if (isDivider(item)) {
      acc.push(item);
      return acc;
    }
    let newItem = item;
    if (newItem.items) {
      const isNewItemVisible = newItem.isVisible ?? true;
      const filteredItems = filterPopoverMenuItems(newItem.items);
      newItem = {
        ...newItem,
        isVisible: !!filteredItems.length && isNewItemVisible,
        items: filteredItems,
      };
    }

    if (newItem.isVisible) {
      acc.push(newItem);
    }
    return acc;
  }, []);
}

export function isDivider(menuItem: IPopoverMenuItem): menuItem is IPopoverMenuDivider {
  return !!menuItem.isDivider;
}
